import { createI18n, I18n } from "vue-i18n"
import En from "./en"
import Zh from "./Zh"
import { LanguagePackageType } from "@/typeDefine/EntityType"
import { ConstantField } from "@/constant/ConstantField"
import { LanguageType } from "@/typeDefine/CommonTypes"


class Translate {
    public static readonly instance: Translate = new Translate()

    private readonly _i18n

    //默认语言
    private static readonly defaultLanguage: LanguageType = 'zh'

    private constructor() {
        this._i18n = createI18n<[LanguagePackageType], LanguageType>({
            locale: this.getLanguageFromLocal(),
            messages: {
                en: En,
                zh: Zh
            }
        })
    }

    public get i18n() {
        return this._i18n
    }

    //从本地获取语言设置
    public getLanguageFromLocal(): LanguageType {
        let language: string | null = localStorage.getItem(ConstantField.LANGUAGE_LOCAL_KEY)
        
        if(!language) {
            language = Translate.defaultLanguage
        }

        if(language !== 'zh' && language !== 'en') {
            return 'zh'
        }

        return language
    }

    public setLanguage2Local(language: LanguageType): void {
        localStorage.setItem(ConstantField.LANGUAGE_LOCAL_KEY,language)
    }
}

const i18n = Translate.instance.i18n
export {i18n , Translate}